export const mediaApiPathPrefix: any = '/media-api';
